import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ImagesComponent } from './images.component';
import { ImagesService } from '@app/shared/components/images/services/images.service';

@NgModule({
  imports: [CommonModule, LazyLoadImageModule],
  declarations: [ImagesComponent],
  exports: [ImagesComponent],
  providers: [ImagesService]
})
export class ImagesModule {}
